const Loading = () => {
    return <div className="preloader"></div>;
};

export default Loading;
